module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kg-Ld.a9f7565e.png";